import styled from 'styled-components';
import UiKitAccordion from '@westwing/ui-kit/Accordion';
import { body2 } from '@westwing/ui-kit/typography';
import Text from '@ids/components/Typography/Text';
import Heading from '@ids/components/Typography/Heading';
import { scrollMarginToSection } from '@ids/components/Layout/utils';

export const FAQSection = styled.section`
    padding: 10px min(5vw, 40px);

    ${scrollMarginToSection}
`;

export const Accordion = styled(UiKitAccordion)`
    h2 {
        margin: 0;
    }
`;

export const Question = styled(Text)`
    margin: 1em 1em 1em 0;
`;

export const Answer = styled(Text)`
    ${body2}
    margin-bottom: 1em;

    & > * {
        margin: 0;
    }
`;

export const SectionHeading = styled(Heading)`
    margin-bottom: 40px;
`;
